// Maximum number of items that are allowed to be ordered for any one SKU.
export const MAX_ORDER_QUANTITY = 999